const SMTP_CONFIG_KEY = 'amc_smtp_config_v1';

export const DEFAULT_SMTP_CONFIG = {
  smtpServer: '',
  port: '587',
  email: '',
  password: ''
};

const normalizePort = (value) => {
  const trimmed = String(value ?? '').trim();
  const parsed = Number(trimmed);

  if (!Number.isInteger(parsed) || parsed <= 0 || parsed > 65535) {
    return DEFAULT_SMTP_CONFIG.port;
  }

  return String(parsed);
};

const normalizeSmtpConfig = (config = {}) => {
  return {
    smtpServer: String(config.smtpServer ?? '').trim(),
    port: normalizePort(config.port),
    email: String(config.email ?? '').trim(),
    password: String(config.password ?? '')
  };
};

export const getSmtpConfig = () => {
  if (typeof window === 'undefined') {
    return { ...DEFAULT_SMTP_CONFIG };
  }

  try {
    const raw = window.localStorage.getItem(SMTP_CONFIG_KEY);
    if (!raw) {
      return { ...DEFAULT_SMTP_CONFIG };
    }

    const parsed = JSON.parse(raw);
    if (typeof parsed !== 'object' || parsed === null) {
      return { ...DEFAULT_SMTP_CONFIG };
    }

    return normalizeSmtpConfig(parsed);
  } catch (_error) {
    return { ...DEFAULT_SMTP_CONFIG };
  }
};

export const saveSmtpConfig = (config) => {
  if (typeof window === 'undefined') {
    return;
  }

  const normalized = normalizeSmtpConfig(config);
  window.localStorage.setItem(SMTP_CONFIG_KEY, JSON.stringify(normalized));
};